import { FC } from 'react';

interface ResetProps {
  handleReset: () => void;
}
const Reset: FC<ResetProps> = ({ handleReset }) => {
    return (
        <div className="btn btn-submit--wrapper">
            <input
                type="reset"
                value={Drupal.t('Réinitialiser')}
                className="button js-form-submit form-submit"
                id="reset-btn"
                onClick={handleReset}
            />
            <i className="icon-arrow-right" aria-hidden="true"></i>
        </div>
    );
};

export default Reset;
